import { gql } from '@apollo/client';

export const GET_MAPS_CONFIGURATION = gql`
  query GetMapsConfiguration($platform: MapsPlatform) {
    mapsConfiguration(platform: $platform)
  }
`;
